import { render } from "./FontTitle.vue?vue&type=template&id=45848e97&scoped=true"
import script from "./FontTitle.vue?vue&type=script&lang=js"
export * from "./FontTitle.vue?vue&type=script&lang=js"

import "./FontTitle.vue?vue&type=style&index=0&id=45848e97&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45848e97"]])

export default __exports__